import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { PopupButton } from '@typeform/embed-react';
import { get } from 'lodash';
import { Profile } from '../../../api/api-profile';
import Cookie from 'react-cookie';
import { useStatsigContext } from '../elements-statsig-provider/utils';

const SURVEY_COOKIE_NAME = 'HostFeatureSurvey';

export const withTypeFormSurvey = (Component) => {
  const HOC = (props) => {
    const [surveyConcluded, setSurveyConcluded] = useState(false);
    const ssoid = get(props, 'profile.SSOid', '');
    const {
      dynamicConfigs,
      featureGates
    } = useStatsigContext(null);

    const { surveyId: configSurveyId, allHosts } = dynamicConfigs?.current_host_survey?.() || {};

    const HostSurveyCookiePresent = PSSessions.Cookies.get(SURVEY_COOKIE_NAME);
    const surveyStatuses = get(props, 'profile.data.metadata.survey_statuses', {});

    const previouslyCompleted = 'COMPLETE' === surveyStatuses[configSurveyId];
    const validSurveyCandidate = !previouslyCompleted && (allHosts || 'INCOMPLETE' === surveyStatuses[configSurveyId]);

    const isIneligibleForSurvey = HostSurveyCookiePresent || !featureGates?.host_surveys?.() || !validSurveyCandidate || !configSurveyId;

    const onSurveyRendered = () => {
      Cookie.save(SURVEY_COOKIE_NAME, true, {
        path: '/',
        expires: new Date((Date.now()) + (24 * 60 * 60 * 1000)),
        domain: window.location.host,
        secure: -1 !== window.location.protocol.indexOf('s')
      });
    };

    function handleSurveySubmit () {
      const accessToken = PSSessions.Cookies.get('PSAccess');
      const path = `${ssoid}/surveys/${configSurveyId}/status/COMPLETE`;
      Profile.update(path, accessToken, null, (res)=>{
        if (400 <= res.status) {
          console.warn('[DEBUG] error calling update to profile survey');
        }
      });
    }

    useEffect(()=>{
      if (surveyConcluded) {
        document.body.style.overflow = 'visible';
      }
    }, [surveyConcluded]);

    return (<>
      <Component {...props} />
      {!isIneligibleForSurvey && !surveyConcluded && <PopupButton
        id={configSurveyId}
        style={{ fontSize: 20, display: 'none' }}
        className="my-button"
        open='load'
        onReady={onSurveyRendered}
        hidden={{ ssoid }}
        size="90"
        onSubmit={handleSurveySubmit}
        onClose={() => setSurveyConcluded(true)}
      />}
    </>);
  };

  HOC.propTypes = {
    profile: PropTypes.object,
    statsigInitialized: PropTypes.boolean
  };

  return HOC;
};
